import { messages } from '../messages/alertMessages';

type ErrorType = {
  [key: string]: [string, string];
};

export const errorMessages: ErrorType = {
  400: ['400 Bad Request', messages.smthWentWrong],
  // 401: ['401 Unauthorized', messages.smthWentWrong.defaultMessage],
  404: ['404 Not Found', messages.errorNotFound],
  500: ['500 Internal Server Error', messages.smthWentWrong],
  502: ['502 Bad Gateway', messages.smthWentWrong],
  503: ['503 Service Unavailable', messages.errorServiceUnavailable],
  504: ['504 Gateway Timeout', messages.errorGatewayTimeout]
};

export const errorUnknownMessage = {
  title: messages.error,
  errorUnknown: messages.errorUnknown
};

export const audioMessages = {
  title: 'Audio',
  uploadingMp3: 'Please upload files in MP3 format',
  uploadingError: 'Error while uploading content'
};

export const transitionMessages = {
  title: 'Transitions',
  loadingError: 'Error while loading transitions'
};

export const templateMessages = {
  title: 'Templates',
  loadingError: 'Error while loading template'
};

export const sceneMessages = {
  title: 'Scenes',
  uploadingTitle: 'Uploading',
  uploading: 'Error while uploading content',
  notFoundTitle: 'Not found',
  notFound: 'Image not found',
  notSupportedTitle: 'Not supported',
  notSupported: "Gif format isn't supported",
  shutterstockTitle: 'Shutterstock url',
  shutterstock: 'Error while loading Shutterstock url',
  stockVideoTitle: 'Stock video url',
  stockVideo: 'Error while loading stock video url',
  templateTitle: 'Template',
  template: "Can't apply template: no files specified",
  xmlTitle: 'XML',
  xml: 'Error while loading xml file'
};

export const projectMessages = {
  title: 'Projects',
  update: 'Error while update project file',
  list: 'Error while get project file list',
  create: 'Error while creating project file'
};

export const effectMessages = {
  fontLoadingTitle: 'Loading font',
  fontLoading: 'Error while loading font',
  fontUploadingTitle: 'Uploading font',
  fontUpoading: 'Error while uploading font'
};

export const downloadMessages = {
  midResTitle: 'Generating resolutions',
  midRes: 'Error while generating mid and low resolutions',
  downloadTemplateTitle: 'Template export',
  downloadTemplate: 'Error while exporting template'
};

export const uploadFileMessages = {
  message: "The file format isn't supported.",
  title: 'Error while uploading file'
};

export const userPaidItemsMessages = {
  title: 'Paid Items',
  loadingError: 'Error while loading Paid Items'
};

export const errorBoundaryMessage = {
  title: messages.error,
  message: messages.smthWentWrongReload
};
